<template>
  <div class="event-card-quota">
    <div class="event-card-quota__count">
      <template v-if="total !== null">
        {{ $t("event.cardQuota.outof", { count, total }) }}

        {{ total | pluralize($t("event.cardQuota.availablePluralize")) }}
      </template>

      <template v-else>
        {{ count }} {{ count | pluralize($t("event.cardQuota.passPluralize")) }}
      </template>
    </div>
    <div v-if="total !== null" class="event-card-quota__wrap">
      <p class="event-card-quota__info">
        {{ $t("event.cardQuota.howToIncrease") }}
      </p>
      <Tooltip>
        <div class="event-card-quota__info">
          <icon name="info" />
        </div>
        <template #content>
          <p class="event-card-quota__tooltip">
            <slot />
          </p>
        </template>
      </Tooltip>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "@v2/shared/ui/components";
export default {
  name: "EventCardQuota",
  components: {
    Tooltip
  },
  props: {
    count: {
      type: [String, Number],
      default: 0
    },
    total: {
      type: [String, Number],
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.event-card-quota {
  border-radius: 2px;
  background-color: #f9f9f9;

  padding: 14px 27px;

  position: relative;

  @include respond-down(md) {
    padding: 12px 16px 12px 24px;
    line-height: 2;
  }
  &__wrap {
    display: flex;
    align-items: flex-end;
  }
  &__count {
    font-size: 16px;
    font-weight: 500;
    color: #505050;
    margin-bottom: 10px;
    @include respond-down(md) {
      font-size: 12px;

      margin-right: 17px;
    }
  }

  &__info {
    padding: 0;
    margin: 0;
    font-size: 12px;
    line-height: 1.5;

    color: #a3a8b3;

    cursor: pointer;

    border: none;
    outline: none;
    background: none;

    @include respond-down(md) {
      font-size: 11px;
    }
    .svg-icon {
      width: 16px;
      height: 16px;

      position: relative;
      top: 4px;

      margin-left: 5px;
      @include respond-down(md) {
        width: 12px;
        height: 12px;
      }
    }
  }
  &__tooltip {
    background-color: #fff;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 1.67;
    color: #6d7179;
    margin: 0;
  }
}
</style>
